import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import ReviewSetupForm, { type StartFrom } from './ReviewSetupForm';

/**
 * "+ New review" (#317): one dialog — a name, the grounding, where it starts
 * from — then the page. The review it starts opens as a tab behind it.
 */
export default function ReviewSetupDialog({ open, onClose, initialFrom }: { open: boolean; onClose: () => void; initialFrom?: StartFrom }) {
  // a start in flight owns the dialog: Escape and the backdrop wait for it, like Cancel does
  const [working, setWorking] = useState(false);
  return (
    <Dialog open={open} onClose={working ? undefined : onClose} disableEscapeKeyDown={working} maxWidth="xs" fullWidth PaperProps={{ 'data-testid': 'review-setup-dialog' } as any}>
      <DialogTitle sx={{ pb: 0.5 }}>
        Start a review
        <Typography variant="caption" sx={{ display: 'block', color: 'text.secondary', mt: 0.25 }}>
          Grounded on a perspective, refreshed on a schedule, built from pinned analyses. Grounding is chosen here and never changes silently.
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <ReviewSetupForm key={initialFrom || 'template'} initialFrom={initialFrom} onDone={onClose} onCancel={onClose} onWorking={setWorking} />
      </DialogContent>
    </Dialog>
  );
}
